/** Palette keys — values live in globals.css (`--patient-tag-color-*`). */
export const PATIENT_TAG_COLORS = [
    {
        bg: "var(--patient-tag-color-1)",
        border: "var(--patient-tag-color-1-border)",
        text: "var(--patient-tag-color-1-text)",
    },
    {
        bg: "var(--patient-tag-color-2)",
        border: "var(--patient-tag-color-2-border)",
        text: "var(--patient-tag-color-2-text)",
    },
    {
        bg: "var(--patient-tag-color-3)",
        border: "var(--patient-tag-color-3-border)",
        text: "var(--patient-tag-color-3-text)",
    },
];
export function getDefaultTagColor(seed) {
    return colorFromIndex(seed.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0) %
        PATIENT_TAG_COLORS.length);
}
export function colorFromIndex(index) {
    const len = PATIENT_TAG_COLORS.length;
    const i = ((index % len) + len) % len;
    return PATIENT_TAG_COLORS[i];
}
export function colorIndexFromColor(color) {
    const idx = PATIENT_TAG_COLORS.findIndex((c) => c.bg === color.bg && c.text === color.text);
    return idx >= 0 ? idx : 0;
}
